import {Injectable} from '@angular/core';
import {Subject, Observable, BehaviorSubject} from 'rxjs';

import {MapaCurricularService} from './mapa-curricular.service';
import {CustomAlertService} from '../../../../_components/custom-alert/custom-alert.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {colores} from './conexiones-colors';
import {scan} from 'rxjs/operators';
import {element} from 'protractor';
import {Meta} from '../../../../_models/meta';
import {Unidad} from '../../../../_models/unidad';

@Injectable({
  providedIn: 'root'
})
export class EstudioConexionesService {
  private subject = new Subject<any>();

  private conexionHabilitada = {isOn: false, id: 0, url: ''};

  colores = colores;

  private connectionsStatusSubject = new BehaviorSubject<any>([]);
  connectionsStatusAction$ = this.connectionsStatusSubject.asObservable()
    .pipe(
      scan((acc, val) => {
        if (val.op === 'add') {
          let existEle = acc.find(accEl => accEl.idEmisor === val.objConexion.idEmisor);
          if (existEle) {
            existEle = val.objConexion;
            return acc;
          } else {
            return acc.concat(val.objConexion);
          }
        }
        if (val.op === 'remove') {
          return acc.filter(el => el.idEmisor !== val.objConexion.idEmisor);
        }
        if (val.op === 'clear') {
          acc = [];
          return acc;
        }
      })
    );

  private enableConnectionsSubject = new Subject();
  enableConnectionsAction$ = this.enableConnectionsSubject.asObservable();

  private emisorClearSubject = new Subject();
  emisorClearAction$ = this.emisorClearSubject.asObservable();

  constructor(
    private mapaCurricularService: MapaCurricularService,
    private customAlertService: CustomAlertService,
    private snackBar: MatSnackBar) {
  }

  contadorConexiones = 0;

  showConexiones(dir, obj) {
    if (obj.conexiones.selfColor === '') {
      obj.conexiones.selfColor = this.getConexionColor();
    }
    if (dir === 'all') {
      const status = obj.conexiones.status.up || obj.conexiones.status.same || obj.conexiones.status.down;
      obj.conexiones.status.up = !status;
      obj.conexiones.status.down = !status;
      obj.conexiones.status.same = !status;
    } else {
      obj.conexiones.status[dir] = !obj.conexiones.status[dir];
    }
    obj.conexiones.active = obj.conexiones.status.up || obj.conexiones.status.same || obj.conexiones.status.down
      || obj.conexiones.status.metaUnidad;
    obj.conexiones.activeColor = obj.conexiones.active ? obj.conexiones.selfColor : '';
    obj.conexiones.idEmisor = obj.id;
    obj.conexiones.tipoEmisor = obj instanceof Meta ? 'meta' : 'unidad';

    this.contadorConexiones = obj.conexiones.active ? this.contadorConexiones + 1 : this.contadorConexiones - 1;


    this.connectionsStatusSubject.next({objConexion: obj.conexiones, op: obj.conexiones.active ? 'add' : 'remove'});

  }

  showConexionesUnidad(objConexion, id) {

  }

  limpiarConexiones() {
    this.connectionsStatusSubject.next({op: 'clear'});
    this.emisorClearSubject.next('');
  }

  mostrarSoloConectadas(estado) {
    this.subject.next({tipo: 'visibilidadSoloConectadas', estado});
  }

  habilitarConexiones(objeto, status) {
    this.conexionHabilitada = {
      isOn: status,
      id: status ? objeto.id : 0,
      url: (objeto instanceof Unidad ? 'Unidades/meta/conectar' : 'Metas/conectar')
    };
    this.enableConnectionsSubject.next({type: status ? 'habilitarConexiones' : 'conexionFinalizada', objeto: objeto, status: status});
    /*this.subject.next({tipo: 'habilitarConexiones', objeto});
    if (!estado) {
      this.subject.next({tipo: 'conexionFinalizada'});
    }*/
  }

  guardarEstadoConexion(objeto) {
    const objConexion = {
      idOrigen: this.conexionHabilitada.id,
      idDestino: objeto.id,
      isConectada: objeto.estado,
      url: this.conexionHabilitada.url
    };

    const req = this.mapaCurricularService.setEstadoConexion(objConexion);
    const sub = req.subscribe(res => {
      const objetoCon = {
        idOrigen: this.conexionHabilitada.id,
        idDestino: objeto.id,
        estado: objeto.estado,
        categoriaDestino: objeto.categoria,
        tipoEmisor: this.conexionHabilitada.url
      };

      const snackRef = this.snackBar.open(
        `La meta ${objetoCon.idOrigen} se ha ${objeto.estado ? 'conectado' : 'desconectado'}
         con éxito ${objeto.estado ? 'a' : 'de'} la meta ${objetoCon.idDestino}.`,
        'Deshacer',
        {duration: 3500});

      snackRef.afterDismissed().subscribe(check => {
        if (check.dismissedByAction) {
          objConexion.isConectada = !objConexion.isConectada;
          this.mapaCurricularService.setEstadoConexion(objConexion).subscribe(() => {
            this.snackBar.open('¡Hecho!', null, {duration: 1500});
          });
          this.subject.next({tipo: 'resultadoConexion', objeto: {estado: objConexion.isConectada, id: objConexion.idDestino}});
          objetoCon.estado = objConexion.isConectada;
          this.subject.next({'tipo': 'estadoConexion', objeto: objetoCon});
        }
      });

      this.subject.next({'tipo': 'estadoConexion', objeto: objetoCon});
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible realizar la acción. Es posible que la conexión ya exista.<br> <ul><li>
Caso 1: La conexion existe desde la meta que intenta ${objeto.estado ? 'conectar' : 'desconectar'}.</li></ul>`
      });
    }, () => {
      sub.unsubscribe();
    });
  }

  habilitarConexionesUnidad(idMetaUnidad, idMeta, lista, estado) {
    const objeto = {idMetaUnidad, idMeta, lista, estado};
    this.subject.next({tipo: 'habilitarConexionesUnidad', objeto});
  }

  updateConexionUnidadMetas(objeto) {
    this.subject.next({tipo: 'actualizarConexionMeta', objeto});
  }

  getConexionColor() {
    const color = this.colores[Math.floor(Math.random() * this.colores.length) + 1],
      indiceColor = this.colores.indexOf(color);
    if (indiceColor > -1) {
      this.colores.splice(indiceColor, 1);
    }
    return color;
  }


  getConexionesObservable(): Observable<any> {
    return this.subject.asObservable();
  }
}
